import { updateCustomerById } from "../../../app/api/updateCustomerById";
import { DEFAULT_SEATING_TYPE } from "../../../Components/Common/Inputs/SeatingInput";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getTranslatedMessage } from "../../../Lib/Utils/i18n";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IMultiBooking } from "../../../Orchestrator/Types/Interface/IBooking";
import { IUserResponse } from "../../../Orchestrator/Types/Index";
import { showNotification } from "../../../Services/notificationService";
import { invalidateUserCaches } from "../MyAccount/invalidateUserCaches";

interface ISaveMultiBookingPreferencesParams {
  userData: IUserResponse;
  multiBookingPreferences: Partial<IMultiBooking>;
}

class SaveMultiBookingPreferencesAction extends BaseAction<void, ISaveMultiBookingPreferencesParams> {
  override async run(): Promise<void> {
    const { userData, multiBookingPreferences } = this.params || {};

    try {
      if (!userData?.id) {
        console.warn("User ID not found.");
        return;
      }

      if (!multiBookingPreferences) {
        console.warn("Multibooking preferences data not provided.");
        return;
      }

      const multiBookingPayload: Partial<IMultiBooking> = {
        ...(userData?.railPreferences?.multiBooking || {}),
        ...multiBookingPreferences,
        seating: multiBookingPreferences.seating ? {
          position: multiBookingPreferences.seating.position || userData?.railPreferences?.multiBooking?.seating?.position || "",
          type: multiBookingPreferences.seating.type || userData?.railPreferences?.multiBooking?.seating?.type || DEFAULT_SEATING_TYPE,
        } : userData?.railPreferences?.multiBooking?.seating,
      };

      // Only send multiBooking in the payload, don't spread all railPreferences
      const response = await updateCustomerById(userData.id.toString(), {
        railPreferences: {
          multiBooking: multiBookingPayload,
        }
      });

      if (response.status === "ok" && response.answer) {
        updateRecoilState("userDataAtom", response.answer);
        invalidateUserCaches();
      } else {
        console.warn("Failed to save multibooking preferences.");
      }
    } catch (error) {
      console.log("Error saving multibooking preferences:", error);
      throw error;
    }
  }
}

export const saveMultiBookingPreferencesAction = new SaveMultiBookingPreferencesAction();
